<template>
  <div class="conversation-input-float">
    <PageContainer class="content d-flex">
      <div class="text-container d-flex justify-space-between flex-grow-1">
        <TextArea class="textarea overlay" :placeholder="$t('enter_msg')" v-model="text" />
        <div class="textarea basis" v-text="text" />
        <v-menu
            top
            close-on-content-click
          >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="mr-3">mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="dialog=true">
              <v-list-item-title><v-icon class="mr-3">mdi-paperclip</v-icon>写真を追加する</v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-title class="text--disabled"><v-icon class="mr-3">mdi-cart</v-icon>注文依頼をする<v-chip
              class="ma-2"
              color="#007e57"
              outlined
              style="font-size: 12px"
            >
              <v-icon left small>
                mdi-wrench
              </v-icon>
              開発中
            </v-chip></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <Button
        size="none"
        class="button align-self-end"
        :on-click="send"
        :disabled="!text || busy"
      >{{ $t("send") }}</Button>
    </PageContainer>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          <div class="d-flex" style="width: 100%">
            <div class="flex-grow-1" style="text-align:center;">{{ $t("upload_files") }}</div>
            <span @click="dialog=false" style="cursor: pointer">&times;</span>
          </div>
        </v-card-title>
        <v-card-text>
          <div style="text-align: center">
            <div class="text-container d-flex justify-space-between flex-grow-1">
              <TextArea class="textarea overlay" :placeholder="$t('enter_msg')" v-model="text" />
              <div class="textarea basis" v-text="text" />
            </div>

            <div class="drop-zone d-flex justify-center align-center mt-4">
              <img-handler v-if="dialog" @finish="e=>img = e" disable-cropper full-preview />
            </div>
            <div v-if="imgToBig" style="color: red">{{ $t("img_oversize") }}</div>
            <v-btn class="green mt-3 mr-auto" :disabled="!text || busy" @click="send">{{ $t("send") }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageContainer from "@/components/shop/PageContainer.vue";
import Button from "@/components/shop/Button.vue";
import TextArea from "@/components/shop/TextArea.vue";
import ImgHandler from "@/components/shared/ImgHandler/index.vue";

export default {
  components: {
    PageContainer,
    Button,
    TextArea,
    ImgHandler
  },

  props: {
    onSend: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      text: "",
      img: null,
      dialog: false,
      imgToBig: false,
      busy: false
    };
  },

  watch: {
    dialog() {
      if (!this.dialog) {
        this.img = null;
      }
    }
  },

  methods: {
    async send() {
      this.busy = true;
      this.imgToBig = false;

      if (this.img && this.img === "OVERSIZE") {
        this.imgToBig = true;
        return;
      }

      await this.onSend({ body: this.text, image: this.img });
      this.text = "";
      this.img = null;
      this.dialog = false;
      this.busy = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.conversation-input-float {
  position: sticky;
  bottom: 0;
  background: #ffffffeb;
  min-width: 0;
}

.content {
  padding: 16px;
}

.text-container {
  position: relative;
  min-height: 44px;
  margin-right: 16px;
  overflow: hidden;
}

.textarea {
  font-size: 14px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  padding: 10px 16px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 200px;

  &.overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
  }

  &.basis {
    border: transparent 1px solid;
    visibility: hidden;

    &::after {
      display: inline-block;
      content: "";
      width: 1px;
      height: 1px;
    }
  }
}

.button {
  height: 44px;
  width: 140px;

  @media screen and (max-width: 960px) {
    width: 80px;
  }
}

.drop-zone {
  height: 300px;
}
</style>
